import { render, staticRenderFns } from "./YearlyByClass.vue?vue&type=template&id=2b6e783e&"
import script from "./YearlyByClass.vue?vue&type=script&lang=js&"
export * from "./YearlyByClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports